define( [
	"../../core",
	"../../selector"
], function( jQuery ) {
	"use strict";

	return jQuery.expr.match.needsContext;
} );



//////////////////
// WEBPACK FOOTER
// /srv/_versions/easypost-web/easypost-web-201706012359-95877d6b9a-master/~/jquery/src/traversing/var/rneedsContext.js
// module id = 303
// module chunks = 1